import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=44107984&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44107984')) {
      api.createRecord('44107984', component.options)
    } else {
      api.reload('44107984', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=44107984&", function () {
      api.rerender('44107984', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26Y53V2d45JhP/JS/imageCarousel.vue"
export default component.exports